import { Component, isDevMode, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { versions } from '@environments/versions';
import { MessagingService } from '@reusable/services/messaging.service';
import { UsersService } from '@reusable/services/users/users.service';

@Component({
  selector: 'app-customers-home',
  standalone: false,
  templateUrl: './customers-home.component.html',
  styleUrls: ['./customers-home.component.scss']

})
export class CustomersHomeComponent implements OnInit {
  message;
  version = versions.version;
  _devMode = isDevMode();

  constructor(private router: Router, private notifications: MessagingService, private user: UsersService, private title: Title) {}

  ngOnInit() {
    this.notifications.getPermission();
    this.notifications.receiveMessage();
    this.message = this.notifications.currentMessage;
  }
}